/**
 * In some cases price data doesn't have currency. Decision to rely on
 * current locale is done under https://jira.shop-apotheke.com/browse/WSAWA-4431.
 */
export const i18nGetCurrencyForLocale = (locale: string): string => {
  if (locale.includes('CH')) {
    return 'CHF'
  }

  return 'EUR'
}
